import { PositionRange } from '../../types'

export function validateVisibleRange(range: PositionRange, length: number): PositionRange {
  if (range[1] - range[0] >= length) {
    return [0, length]
  } else if (range[0] < 0) {
    return [0, range[1] - range[0]]
  } else if (range[1] > length) {
    return [range[0] - (range[1] - length), length]
  } else if (range[0] > range[1]) {
    return validateVisibleRange([range[1], range[0]], length)
  } else {
    return range
  }
}
